import React, {useState, useEffect, useRef, useCallback} from 'react'

import BrassPanel from '../../../components/BrassPanel'

function MachineDials({setPlayerInput, resetGame}) {
    const [dialInput, setDialInput] = useState([1, 1, 1])
    const dialRef0 = useRef()
    const dialRef1 = useRef()
    const dialRef2 = useRef()
    const [dialRefs] = useState([dialRef0, dialRef1, dialRef2])
    
    function handleDialChange(dialRef, dial, num) {
        const newArr = [...dialInput]
        rotateDial(dialRef, num)
        newArr[dial] = num
        setDialInput(newArr)
        updatePlayerInput(newArr)
    }
    
    function rotateDial(dialRef, num) {
        const rotation = (num - 1) * 90
        dialRef.current.style.transform = `rotate(${rotation}deg)`
    }
    
    const updatePlayerInput = useCallback((newArr) => {
        setPlayerInput(prevInput => {
            return ({
                ...prevInput,
                dials: newArr.join('')
            })
        })
    }, [setPlayerInput])
    
    function buttonSetUp(num, dial, index) {
        return (
            <button
                className='dial_number'
                onClick={() => handleDialChange(dial, index, num)}
            >{num}</button>
        )
    }
    
    useEffect(() => {
        if (resetGame) {
            dialRefs.forEach(dialRef => {
                rotateDial(dialRef, 1)
            })
            const resetArr = [1, 1, 1]
            setDialInput(resetArr)
            updatePlayerInput(resetArr)
        }
    }, [resetGame, dialRefs, updatePlayerInput])
    
    return (
        <BrassPanel extraClasses='machine_panel machine_panel-dials'>
            {dialRefs.map((dial, index) => {
                return (
                    <div key={index} className='machine_dial' >
                        <div className='dial_arrowContainer' ref={dial}>
                            <div className='dial_arrow'></div>
                        </div>
                        <div className='dial_numberContainer dial_numberContainer-1'>
                            {buttonSetUp(1, dial, index)}
                            {buttonSetUp(3, dial, index)}
                        </div>
                        <div className='dial_numberContainer dial_numberContainer-2'>
                            {buttonSetUp(2, dial, index)}
                            {buttonSetUp(4, dial, index)}
                        </div>
                    </div>
                )
            })}
        </BrassPanel>
    )
}

export default MachineDials